import React, { useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

const Registro = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [userDetails, setUserDetails] = useState({
    nombre: "",
    apellidos: "",
    correo: "",
    fechaNacimiento: "",
    telefono: "",
    tipoContacto: "WhatsApp",
    referido: "",
    terminos: false,
  });

  const handleRegister = (e) => {
    e.preventDefault();
    setIsOpen(true);
  };

  return (
    <div className="max-w-2xl mx-auto bg-white p-6 rounded-lg shadow-md mt-10">
      <h2 className="text-2xl font-bold text-blue-600 text-center">Registro</h2>
      <p className="text-gray-600 text-center mb-4">
        Completa el formulario para crear tu cuenta
      </p>

      <form onSubmit={handleRegister} className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Nombre */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Nombre</label>
          <input
            type="text"
            required
            value={userDetails.nombre}
            onChange={(e) => setUserDetails({ ...userDetails, nombre: e.target.value })}
            className="w-full p-2 border rounded-md"
          />
        </div>

        {/* Apellidos */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Apellidos</label>
          <input
            type="text"
            required
            value={userDetails.apellidos}
            onChange={(e) => setUserDetails({ ...userDetails, apellidos: e.target.value })}
            className="w-full p-2 border rounded-md"
          />
        </div>

        {/* Correo Electrónico */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Correo Electrónico</label>
          <input
            type="email"
            required
            value={userDetails.correo}
            onChange={(e) => setUserDetails({ ...userDetails, correo: e.target.value })}
            className="w-full p-2 border rounded-md"
          />
        </div>

        {/* Fecha de Nacimiento */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Fecha de Nacimiento</label>
          <input
            type="date"
            required
            value={userDetails.fechaNacimiento}
            onChange={(e) => setUserDetails({ ...userDetails, fechaNacimiento: e.target.value })}
            className="w-full p-2 border rounded-md"
          />
        </div>

        {/* Teléfono */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Teléfono</label>
          <input
            type="tel"
            required
            value={userDetails.telefono}
            onChange={(e) => setUserDetails({ ...userDetails, telefono: e.target.value })}
            className="w-full p-2 border rounded-md"
          />
        </div>

        {/* Tipo de contacto */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Tipo de Contacto</label>
          <select
            value={userDetails.tipoContacto}
            onChange={(e) => setUserDetails({ ...userDetails, tipoContacto: e.target.value })}
            className="w-full p-2 border rounded-md"
          >
            <option value="WhatsApp">WhatsApp</option>
            <option value="Telegram">Telegram</option>
            <option value="Viber">Viber</option>
          </select>
        </div>

        {/* Código de Referido */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700">Código de Referido</label>
          <input
            type="text"
            value={userDetails.referido}
            onChange={(e) => setUserDetails({ ...userDetails, referido: e.target.value })}
            className="w-full p-2 border rounded-md"
          />
        </div>

        {/* Términos y Condiciones */}
        <div className="md:col-span-2 flex items-center">
          <input
            type="checkbox"
            required
            checked={userDetails.terminos}
            onChange={(e) => setUserDetails({ ...userDetails, terminos: e.target.checked })}
            className="mr-2"
          />
          <label className="text-sm text-gray-700">
            Acepto los{" "}
            <a href="/terminos" className="text-blue-600 hover:underline">
              Términos y Condiciones
            </a>
          </label>
        </div>

        {/* Botón de Registro */}
        <div className="md:col-span-2">
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700"
          >
            Registrarse
          </button>
        </div>
      </form>

      {/* MODAL ALERTA */}
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={() => setIsOpen(false)}>
          <div className="fixed inset-0 bg-black bg-opacity-25 flex items-center justify-center">
            <Dialog.Panel className="bg-white p-6 rounded-lg shadow-lg max-w-md">
              <Dialog.Title className="text-lg font-bold text-gray-900 text-center">
                Registro en Mantenimiento
              </Dialog.Title>
              <p className="text-gray-600 text-center mt-2">
                Nuestro registro está en mantenimiento. Inténtalo más tarde. <br />
                ¡Gracias por tu comprensión!
              </p>
              <button
                className="mt-4 w-full bg-red-600 text-white py-2 rounded-md hover:bg-red-700"
                onClick={() => setIsOpen(false)}
              >
                Cerrar
              </button>
            </Dialog.Panel>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default Registro;
